export default __webpack_public_path__ + "_/images/registration/registration_en-0bc9f86e2c1975993d5c805b50f6279396a1de388a592f14f593a48a75d42a80.jpg";